(function() {
  'use strict';

  angular.module('component.faqs', []);
})();
